Ext.define('SA.controller.ManageImportsController', {
    alias: 'controller.manage-imports-controller',

    constructor() {
        this.mainWindow = Ext.widget({xtype: 'manage-imports-window'});

        this.initEvents();
    },

    attemptNameChange(datasetId, name) {
        if (!name) {
            return;
        }

        if (SA.data.UserDatasets.isDuplicateName(name)) {
            let currentName = SA.data.UserDatasets.getName(datasetId);

            Ext.widget({xtype: 'rename-dataset-error-window', currentName, proposedName: name});

            return;
        }

        SA.data.UserDatasets.rename(datasetId, name);

        this.mainWindow.updateName(datasetId, name);
    },

    destroy() {
        Ext.destroyMembers(this, 'mainWindow', 'renameMenu');
    },

    initEvents() {
        this.mainWindow.on('click:delete', this.showDeletionWindow, this);
        this.mainWindow.on('click:editName', this.showRenameDatasetPopup, this);
        this.mainWindow.on('click:closeBtn', this.destroy, this);
    },

    async onDeletionConfirmed(datasetId) {
        this.deletionWindow.setDeleting();

        await SA.data.UserDatasets.delete(datasetId);

        this.mainWindow.removeDataset(datasetId);

        Ext.destroyMembers(this, 'deletionWindow');

        if (!SA.data.UserDatasets.hasDatasets()) {
            this.destroy();
        }
    },

    showDeletionWindow(datasetId) {
        this.deletionWindow = Ext.widget({
            xtype: 'delete-dataset-window',
            datasetName: SA.data.UserDatasets.getName(datasetId),

            listeners: {
                'click:delete': () => this.onDeletionConfirmed(datasetId)
            }
        });
    },

    showRenameDatasetPopup(datasetId) {
        var name = SA.data.UserDatasets.getName(datasetId),
            menu = this.renameMenu,
            leaveMenuClosed = menu && menu.wasRecentlyVisible() && menu.datasetId === datasetId,
            positionEl = this.mainWindow.getNameElForDatasetId(datasetId);

        if (leaveMenuClosed) {
            return;
        }

        Ext.destroyMembers(this, 'renameMenu');

        this.renameMenu = Ext.widget({
            xtype: 'rename-menu',
            datasetId,
            handler: name => this.attemptNameChange(datasetId, name),
            maxLength: 40,
            name,
            positionEl,
            target: this.mainWindow,
            track: true,
            width: 320
        });
    }
});